module.exports = __webpack_public_path__ + "/hashedassets-launcher/logo.9a06a31283bb958af1e6112179685b71.svg";